var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.$style.arrow,attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":_vm.handleChange}},[(_vm.increment)?[_vm._v(" > ")]:[_vm._v(" < ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }